<template>
    <b-row>
        <b-col cols="12" md="6" style="min-height: 80px; display: block;">
            <div class="text-left">
                <span>Filtrar por estado el total de entradas</span>
            </div>
            <multiselect
                v-model="filtersEntradasPrevistas.estado"
                class="mt-1 mb-2 custom-multiselect"
                placeholder="Seleccione estado"
                label="label"
                track-by="value"
                :allow-empty="false"
                :searchable="false"
                :disabled="loadingEntradasPrevistas"
                :options="estadosEntradasPrevistas"
                @input="debouncedGetEntradasPrevistas"
            />
        </b-col>
        <b-col cols="12">
            <b-row>
                <b-col cols="12" md="6">
                    <div class="info-box" id="entradas-previstas">
                        <span class="info-box-icon bg-info">
                            <i class="fas fa-calendar-alt"></i>
                        </span>
                        <div class="d-flex align-items-center">
                            <div class="text-left info-box-content">
                                <span class="info-box-text">TOTAL DE ENTRADAS ACEPTADAS:</span>
                                <span class="font-weight-bold">
                                    <template v-if="!loadingEntradasPrevistas">
                                        {{ entradasPrevistas }}
                                    </template>
                                    <b-spinner small v-else variant="primary" label="Cargando..."/>
                                </span>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="6">
                    <div class="info-box" id="entradas-compradas">
                        <span class="info-box-icon bg-info">
                            <i class="fas fa-ticket-alt"></i>
                        </span>
                        <div class="d-flex align-items-center">
                            <div class="text-left info-box-content">
                                <span class="info-box-text">TOTAL DE ENTRADAS COMPRADAS:</span>
                                <span class="font-weight-bold">
                                    <template v-if="!loadingEntradasCompradas">
                                        {{ entradasCompradas }}
                                    </template>
                                    <b-spinner small v-else variant="primary" label="Cargando..."/>
                                </span>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { usePreventaListado } from '@/composables/admin/events/preventa/usePreventaListado';

    const props = defineProps({
        evento_id: {
            type: [String, Number],
            required: true
        }
    });

    const estadosEntradasPrevistas = [
        { label: 'Pendiente', value: 'pending' },
        { label: 'Aprobada', value: 'selected' },
        { label: 'Denegada', value: 'rejected' },
        { label: 'Comprada', value: 'purchased' }
    ];

    const {
        filtersEntradasPrevistas,
        loadingEntradasPrevistas,
        loadingEntradasCompradas,
        entradasPrevistas,
        getEntradasPrevistas,
        entradasCompradas,
        getEntradasCompradas
    } = usePreventaListado(props.evento_id);

    const debouncedGetEntradasPrevistas = _.debounce(getEntradasPrevistas, 500);

    onMounted(() => {
        getEntradasPrevistas();
        getEntradasCompradas();
    });
</script>
